var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#000","fillRule":"evenodd","d":"M.367 1.64l2.865 3.438a1 1 0 0 0 1.536 0L7.633 1.64A1 1 0 0 0 6.865 0h-5.73a1 1 0 0 0-.768 1.64z"}));
}

Arrow.defaultProps = {"width":"8","height":"6","viewBox":"0 0 8 6"};

module.exports = Arrow;

Arrow.default = Arrow;
